import { gsap } from 'gsap';

class Animate {
  constructor() {
    Animate.bind();
  }

  static triggerAnimate(data) {
    const el = data.detail;

    if (el.dataset.aos === 'animate') {
    //  data.type === 'aos:in' ? this.animate(el) : this.hide(el, true);
      if (data.type === 'aos:in') this.animate(el);
      else this.hide(el, true);
    }
  }


  static animate(el, quick = false) {
    const time = !quick ? 1 : 0;

    switch (el.dataset.animate) {
      case 'ill-circles-why':
        this.illCirclesWhy(el, time);
        break;

      case 'ill-circles-legal':
        this.illCirclesLegal(el, time);
        break;

      case 'ill-circles-partners':
        this.illCirclesPartners(el, time);
        break;

      case 'ill-circles-covid':
        this.illCirclesCovid(el, time);
        break;

      case 'ill-chatsupport':
        this.chatsupportAnimate(el, time);
        break;

      default:
        console.warn(`animation type "${el.dataset.animate}" does not exist`);
        break;
    }
  }


  static hide(el, quick = false) {
    const time = !quick ? 0.4 : 0;

    gsap.killTweensOf(el);
    gsap.to(el, {
      y: 20,
      opacity: 0,
      ease: 'power2.out',
      clearProps: 'all',
      duration: time,
    });
  }

  static chatsupportAnimate(el, time) {
    const messageBubbles = el.querySelectorAll('.js-message-bubble');
    const chatWrap = el.querySelector('.js-chat-wrap');

    const tl = gsap.timeline({ paused: true, defaults: { duration: time, ease: 'power3.out' } });

    tl.kill();
    tl.set(el, { opacity: 1 })
      .fromTo(chatWrap, {
        opacity: 0,
      }, {
        opacity: 1,
      })
      .fromTo(messageBubbles, {
        yPercent: 50,
        opacity: 0,
      }, {
        yPercent: 0,
        opacity: 1,
        stagger: time * -0.4,
      }, `<${time * 0.5}`);
    tl.play();
  }


  static illCirclesWhy(el, time) {
    const circlePrimary = el.querySelector('.js-circle-primary');
    const circleLeft = el.querySelector('.js-circle-other-left');
    const circleCentre = el.querySelector('.js-circle-other-centre');
    const circleRight = el.querySelector('.js-circle-other-right');

    const tl = gsap.timeline({ paused: true, defaults: { duration: time, ease: 'power3.out' } });

    tl.kill();
    tl.set(el, { opacity: 1 })
      .fromTo(circleCentre, {
        scale: 0.5,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        scale: 1,
        opacity: 1,
      })
      .fromTo(circleLeft, {
        xPercent: 80,
        scale: 0.5,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        xPercent: 0,
        scale: 1,
        opacity: 1,
      }, `<${time * 0.1}`)
      .fromTo(circleRight, {
        xPercent: -80,
        scale: 0.5,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        xPercent: 0,
        scale: 1,
        opacity: 1,
      }, `<${time * 0.1}`)
      .fromTo(circlePrimary, {
        yPercent: 100,
        scale: 0.75,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        yPercent: 0,
        scale: 1,
        opacity: 1,
      }, `<${time * 0.2}`);

    tl.play();
  }


  static illCirclesLegal(el, time) {
    const circlePrimary = el.querySelector('.js-circle-primary');
    const circleOther = el.querySelectorAll('.js-circle-other');

    const tl = gsap.timeline({ paused: true, defaults: { duration: time, ease: 'power3.out' } });

    tl.kill();
    tl.set(el, { opacity: 1 })
      .fromTo(circleOther, {
        yPercent: 50,
        scale: 0.5,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        yPercent: 0,
        scale: 1,
        opacity: index => (index + 1) * 0.25,
        stagger: time * 0.1,
      })
      .fromTo(circlePrimary, {
        yPercent: 50,
        scale: 0.75,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        yPercent: 0,
        scale: 1,
        opacity: 1,
      }, `<${time * 0.5}`);

    tl.play();
  }


  static illCirclesPartners(el, time) {
    const circlePrimary = el.querySelector('.js-circle-primary');
    const circleOther = el.querySelectorAll('.js-circle-other');

    const tl = gsap.timeline({ paused: true, defaults: { duration: time, ease: 'power3.out' } });

    tl.kill();
    tl.set(el, { opacity: 1 })
      .fromTo(circleOther, {
        scale: 0.5,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        scale: 1,
        opacity: 1,
        stagger: time * 0.1,
      })
      .fromTo(circlePrimary, {
        scale: 1.1,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        scale: 1,
        opacity: 1,
      }, `<${time * 0.175}`);

    tl.play();
  }

  static illCirclesCovid(el, time) {
    const circlePrimary = el.querySelectorAll('.js-circle-primary');
    const circleTop = el.querySelector('.js-circle-other-top');
    const circleBottom = el.querySelector('.js-circle-other-bottom');
    const circleCenterBottom = el.querySelector('.js-circle-center-bottom');
    const circleCenterTop = el.querySelector('.js-circle-center-top');

    const tl = gsap.timeline({ paused: true, defaults: { duration: time, ease: 'power3.out' } });

    tl.kill();
    tl.set(el, { opacity: 1 })
      .fromTo(circleBottom, {
        yPercent: -25,
        opacity: 0,
        scale: 0.7,
        transformOrigin: 'center center',
      }, {
        yPercent: 0,
        opacity: 1,
        scale: 1,
      }, `<${time * 0.1}`)
      .fromTo(circleTop, {
        yPercent: 25,
        opacity: 0,
        scale: 0.7,
        transformOrigin: 'center center',
      }, {
        yPercent: 0,
        opacity: 1,
        scale: 1,
      }, `<${time * 0.1}`)
      .fromTo(circleCenterBottom, {
        yPercent: -70,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        yPercent: 0,
        opacity: 1,
        scale: 1,
      }, `<${time * 0.1}`)
      .fromTo(circleCenterTop, {
        yPercent: 70,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        yPercent: 0,
        opacity: 1,
        scale: 1,
      }, `<${time * 0.1}`)
      .fromTo(circlePrimary, {
        scale: 0.7,
        opacity: 0,
        transformOrigin: 'center center',
      }, {
        scale: 1,
        opacity: 1,
      }, `<${time * 0.15}`);

    tl.play();
  }


  static bind() {
    document.addEventListener('aos:in', e => this.triggerAnimate(e));
    document.addEventListener('aos:out', e => this.triggerAnimate(e));
  }
}

export default Animate;
